//Core
import React from "react"

//styles
import style from "./style.module.scss"

const ListWithBullet = ({ list = [], color, textStyle }) => {
  return (
    <ul className={style.withBullet} style={{ color: color }}>
      {list.map((text, key) => (
        <li key={key}>
          <span style={textStyle}>{text}</span>
        </li>
      ))}
    </ul>
  )
}

export default ListWithBullet
